import { Box } from "theme-ui"
import { useTranslation } from "react-i18next"
import { Button, MyTableComponent } from "components"
import openIcon from "./selecticon.png"

export const BlockingTimes = () => {
 // language translator
 const { t } = useTranslation("translation")
 const data = [
  {
   info1: "F1",
  },
  {
   info1: "F1",
  },
  {
   info1: "F1",
  },
  {
   info1: "F1",
  },
  {
   info1: "F1",
  },
  {
   info1: "F1",
  },
  {
   info1: "F1",
  },
 ]

 const columns = [
  { Header: t("signalGroup"), accessor: "info1" },
  {
   Header: t("earliestRelease"),
   Cell: () => (
    <div className="bg-gray py-2 flex justify-between items-center rounded px-2">
     <input
      className="w-full  outline-none bg-transparent"
      min="0"
      max="999"
      type="number"
      placeholder="0"
     />
    </div>
   ),
  },
  {
   Header: t("latestRelease"),
   Cell: () => (
    <div className="bg-gray py-2 flex justify-between items-center rounded px-2">
     <input
      className="w-full outline-none bg-transparent"
      min="0"
      max="999"
      type="number"
      placeholder="0"
     />
    </div>
   ),
  },
  {
   Header: t("earliestBlockingTime"),
   Cell: () => (
    <div className="bg-gray py-2 flex justify-between items-center rounded px-2">
     <input
      className="w-full outline-none bg-transparent"
      min="0"
      max="999"
      type="number"
      placeholder="0"
     />
    </div>
   ),
  },
  {
   Header: t("latestBlockingPeriod"),
   Cell: () => (
    <div className="bg-gray py-2 flex justify-between items-center rounded px-2">
     <input
      className="w-full outline-none bg-transparent"
      min="0"
      max="999"
      type="number"
      placeholder="0"
     />
    </div>
   ),
  },
 ]

 return (
  <div className="w-[96%] mx-auto pt-7 relative">
   <h1 className="font-semibold Jakarta-font text-lg pb-2">{t("defineReleaseAndBlockingTimes")}</h1>
   <Box bg="light_gray" color="text-black">
    <ul className="flex w-[100%] Jakarta-font overflow-x-auto hide-scroll-icon py-3">
     <li className="text-xs opacity-70 cursor-pointer px-2 lg:px-4 md:px-4 whitespace-nowrap">
      <a href="/">STm.5</a>
     </li>
     <li className="text-xs opacity-70 cursor-pointer px-2 lg:px-4 md:px-4 whitespace-nowrap">
      <a href="/">STm.6</a>
     </li>
     <li className="text-xs opacity-70 cursor-pointer px-2 lg:px-4 md:px-4 whitespace-nowrap">
      <a href="/">Testanglag 01</a>
     </li>
     <li className="text-xs opacity-70 cursor-pointer px-2 lg:px-4 md:px-4 whitespace-nowrap">
      <a href="/">Testanglag 01 Copy</a>
     </li>
     <li className="text-xs opacity-70 cursor-pointer px-2 lg:px-4 md:px-4 whitespace-nowrap">
      <a href="/">UCM-Test</a>
     </li>
     <li className="text-xs opacity-70 cursor-pointer px-2 lg:px-4 md:px-4 whitespace-nowrap">
      <a href="/"> XXX XXX</a>
     </li>
    </ul>
   </Box>

   <Box bg="highlight" className="px-2">
    <div className="flex pt-2">
     <div>
      <Button size={"sm"}>SZP 1</Button>
     </div>
     <div className="mx-2">
      <Button size={"sm"} color={"white"}>
       SZP 2
      </Button>
     </div>
     <div>
      <Button size={"sm"} color={"white"}>
       SZP 3
      </Button>
     </div>
    </div>
    <div className="flex items-center justify-between py-4">
     <h1>{`${t("orbitalTime")}:`}</h1>
     <Box bg="light_gray" className="py-2 rounded w-[85%] pl-2">
      90
     </Box>
    </div>
    <Box bg="light_gray" className="py-2 rounded flex justify-between px-2 mb-4">
     <h1>{t("stretch")}</h1>
     <div className="h-6 w-6 rounded bg-dark-yellow flex items-center justify-center cursor-pointer">
      <img className="rotate-180" src={openIcon} alt="icon" />
     </div>
    </Box>

    <MyTableComponent fullHeight={true} columns={columns} data={data} paginate={true} />
    <div className="flex justify-start pt-2">
     <div>
      <Button color={"green"} size={"doublexl"}>
       {t("save")}
      </Button>
     </div>
    </div>
   </Box>
  </div>
 )
}
